import { render } from "./EntityDetails.vue?vue&type=template&id=021535a5"
import script from "./EntityDetails.vue?vue&type=script&lang=js"
export * from "./EntityDetails.vue?vue&type=script&lang=js"

import exportComponent from "/builds/oleksandr.makhovskyi/admin-template/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__